import {useState, useEffect} from "react";
import {Link, Navigate, Route, Routes, useLocation, useParams} from "react-router-dom";
import Welcome from "../pages/welcome";
import FindProducts from "../pages/find-products";
import CartPage from "../pages/cart-page";
import DistributorsPage from "../pages/distributors-page";
import DistributorPage from "../pages/distributor-page";
import OrdersPage from "../pages/orders-page";
import AllProducts from "../pages/all-product-distributor-page";
import AllNotificationsPage from "../notifications/all-notifications-page";
import {Box, Button, Typography, useMediaQuery, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import PharmaciesPage from "../pages/pharmacies-page";
import PharmacyPage from "../pages/pharmacy-page"
import AllMessagesPage from "../pages/all-messages-page";
import UserManagementPage from "../pages/user-management-page";
import CourierManagementPage from "../pages/courier-management-page";
import CourierTrackingPage from "../pages/courier-tracking-page";
import CourierProfilePage from "../pages/courier-profile-page";
import CourierProfilesPage from "../pages/courier-profiles-page";

function CourierRouteRedirect() {
    const {id} = useParams();
    const {search, hash, state} = useLocation();
    // Preserve bookmarked profile links and navigation state after moving couriers under Users.
    return <Navigate replace to={`/distributor/users/couriers${id ? `/${encodeURIComponent(id)}` : ""}${search}${hash}`} state={state}/>;
}

function CourierDashboardRedirect() {
    const {search, hash, state} = useLocation();
    return <Navigate replace to={`/distributor/users/couriers${search}${hash}`} state={state}/>;
}

// Nav state is kept here since it belongs to layout, not user identity
function Routing() {
    const [navOpen, setNavOpen] = useState(true);
    const {t} = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const toggleNav = () => setNavOpen(prev => !prev);

    useEffect(() => {
        setNavOpen(!isSmallScreen);
    }, [isSmallScreen]);

    // navOpen and toggleNav are layout concerns shared via props to page shells.
    // User identity (userFullName, tenantType, etc.) is consumed directly from
    // UserContext inside each page/component that needs it.
    const navProps = {navOpen, toggleNav};

    return (
        <Routes>
            <Route path="/" element={<Navigate to="/welcome" replace />} />
            <Route path="/welcome"            element={<Welcome {...navProps} />} />
            <Route path="/pharmacy/products"  element={<FindProducts {...navProps} />} />
            <Route path="/distributor/all-products" element={<AllProducts {...navProps} />} />
            <Route path="/basket"             element={<CartPage {...navProps} />} />
            <Route path="/distributors"       element={<DistributorsPage {...navProps} />} />
            <Route path="/distributors/distributor/:id" element={<DistributorPage {...navProps} />} />
            <Route path="/pharmacy/my-orders" element={<OrdersPage {...navProps} />} />
            <Route path="/distributor/my-orders" element={<OrdersPage {...navProps} />} />
            <Route path="/distributor/users" element={<UserManagementPage {...navProps} />} />
            <Route path="/distributor/users/couriers" element={<CourierManagementPage {...navProps} />} />
            <Route path="/distributor/users/couriers/dashboard" element={<CourierDashboardRedirect />} />
            <Route path="/distributor/users/couriers/tracking" element={<CourierTrackingPage {...navProps} />} />
            <Route path="/distributor/users/couriers/profiles" element={<CourierProfilesPage {...navProps} />} />
            <Route path="/distributor/users/couriers/:id" element={<CourierProfilePage {...navProps} />} />
            <Route path="/distributor/couriers" element={<CourierRouteRedirect />} />
            <Route path="/distributor/couriers/:id" element={<CourierRouteRedirect />} />
            <Route path="/distributor/all-notifications" element={<AllNotificationsPage {...navProps} />} />
            <Route path="/pharmacy/all-notifications" element={<AllNotificationsPage {...navProps} />} />
            <Route path="/pharmacies"         element={<PharmaciesPage {...navProps} />} />
            <Route path="/pharmacies/pharmacy/:id" element={<PharmacyPage {...navProps} />} />
            <Route path="/messages"               element={<AllMessagesPage {...navProps} />} />
            <Route path="*" element={
                <Box sx={{p: 4, textAlign: "center"}}>
                    <Typography variant="h5">{t("PageNotFound", "Page not found")}</Typography>
                    <Button component={Link} to="/welcome" sx={{mt: 2}}>
                        {t("ReturnHome", "Return home")}
                    </Button>
                </Box>
            } />
        </Routes>
    );
}

export default Routing;
